import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ThemeService } from '../../../services/theme.service';
import { Utenteservice } from '../../../services/utente.service';
import { OverlaySideFormService } from '../../shared/overlay-side-form/overlay-side-form.service';
import { confirm } from 'devextreme/ui/dialog';
import { alert } from "devextreme/ui/dialog"
import { ComponentService } from '../../../services/component.service';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { NicaMaster } from '../../nica-master-component/nica-master.component';

@Component({
  selector: 'app-anacomuni',
  templateUrl: './anacomuni.component.html',
  styleUrls: ['./anacomuni.component.css']
})
export class AnacomuniComponent extends NicaMaster implements OnInit {

  constructor(

    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,
    public utenteService: Utenteservice,
    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
    private changeDetector: ChangeDetectorRef

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }

  ngOnInit() {
    this.activateRoute.queryParams.subscribe(params => {

      this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName



      this.setGlobalVariableFromParams(params);


    })
  }

  AllEvent = (e: any) => {
    // console.log("eventoooooooooo ",e  )
    /*
    if(e.name=="onKeyDown"){
      let result = e.event.srcElement.id.includes("codiceCER");
      if(result===true)
      {
        e.event.key=0;
        return e;
      }  
    }
   */



    /* if(e.rowType === 'data'){
     if(e.column.dataField=="guidAccettazione"){
       if(e.value>"")
           e.cellElement.innerHTML='<img width="32px" title="In attesa di accettazione" src="https://img.icons8.com/external-parzival-1997-flat-parzival-1997/64/000000/external-no-touch-touchless-society-parzival-1997-flat-parzival-1997-1.png"/>';
         else
         e.cellElement.innerHTML='<img width="32px" title="Accettata iscrizione" src="https://img.icons8.com/color/48/000000/checked--v1.png"/>';
           //e.cellElement.innerHTML="<p style='color:red;font-weight: 900;'>In Attesa</p>";
     }
   }*/

    if (e.name == "preparaToolbar") {
      var toolbarItems = e.toolbarOptions.items;
      var r = this.utenteService.DammiTipoUtente();
      var p = e.component.totalCount();
      $.each(toolbarItems, function (_, item) {
        if (item.name === "addRowButton") {
          if (r == 1) {
            // alert(p,"");
            //item.options.visible=(p==0); 
            item.options.onClick = function (args) {
              if (e.component.totalCount() == 0)
                e.component.addRow();
            };
          }
        }
      });
    }
    if (e.name == "onInitNewRow") {
    }
  }
  onRowSelected(e: any) {
    //
  }
  optionalButtonClick2(e: any) {
    //console.log(e);
  }
  validateData() {

  }
  validateEdit() {
  }
  validatePrepared() {

  }
  validateDataFieldPrepared() {

  }

  test(e: any) {
    console.log(e);
  }
  bottoniPerToolbar: any[] = [
    {
      location: "before",
      options: {
        icon: "fa fa-reply",
        text: 'Ritorna',
      }
    }

  ];

} 
